import * as React from "react";
import {ReactElement, Suspense} from "react";
import {withStore} from "react-context-hook";
import Store from "../../stores";
import BookingEngine from "../BookingEngine";
import {getText} from "../../services/configuration.service";

/**
 * App
 * @constructor
 */
const App = (): ReactElement => {

    return (
        <Suspense fallback={getText("booking.loading.label")}>
            <BookingEngine/>
        </Suspense>
    );
};

const store = new Store();

export default withStore(
    App,
    store.initialState(),
    store.storeConfig()
);